import { createTheme, ThemeOptions } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { themeBase } from "./_themeBase";

const theme: ThemeOptions = {
  palette: {
    primary: {
      main: "#528CD6",
      dark: "#002652",
      light: "#A3D4E8",
      base: "#E3F2F8",
      accent: "#FF9D14",
    },
    components: {
      slider: {
        rail: "#E3F2F8",
        track: "#002652",
        thumbIcon: "#F2704F",
        label: "#002652",
      },
      progressBar: {
        rail: "#D9D9D9",
        track: "#FF9D14",
      },
      buttonSelect: {
        backgroundColor: "#528CD6",
        textColor: "#FFFFFF",
        backgroundColorActive: "#002652",
        textColorActive: "#FFFFFF",
        bordeColorActive: "#A3D4E8",
      },
    },
  },
};

export const CustomTheme = createTheme(themeBase, theme);

export const interfaceConfig: InterfaceConfig = {
  name: "pymio",
  home_url: import.meta.env.VITE_URL_HOME_MARKET_PLACE,
  aviso_privacidad: import.meta.env.VITE_URL_HOME_MARKET_PLACE + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_MARKET_PLACE + "/terminos-y-condiciones",
  interest_rate: 30,
  metadata: {
    title: "PYMIO",
    description:
      "PYMIO es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "market_place/portal/logos/favicon.svg",
  },
  navbar: {
    logo: "market_place/portal/logos/logo_light_bg.png",
    logo_width: 142,
    logo_height: 32,
  },
  lateral: {
    logo_light: "market_place/portal/logos/logo_light_bg.png",
    bg_light: "#6387D4",
    text_light: "#FFFFFF",
    logo_dark: "market_place/portal/logos/logo_dark_bg.png",
    bg_dark: "#052649",
    text_dark: "#FFFFFF",
    image_list: [
      "market_place/portal/lateral/imagen_1.webp",
      "market_place/portal/lateral/imagen_2.webp",
      "market_place/portal/lateral/imagen_3.webp",
      "market_place/portal/lateral/imagen_4.webp",
      "market_place/portal/lateral/imagen_5.webp",
      "market_place/portal/lateral/imagen_6.webp",
      "market_place/portal/lateral/imagen_7.webp",
      "market_place/portal/lateral/imagen_8.webp",
      "market_place/portal/lateral/imagen_9.webp",
      "market_place/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Así de fácil: solicita, compara, avanza",
      "Tu crédito, tu elección, tu crecimiento",
      "Crédito simple, procesos simples",
      "Avanza con las mejores condiciones del mercado",
      "Compara y decide: tu crédito, tus reglas",
      "Un solo lugar, todas las opciones de financiamiento",
      "Crecer nunca fue tan sencillo",
      "Descubre la mejor solución para tu PyME",
      "El poder de elegir está en tus manos",
      "Da el paso que tu empresa necesita",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key: import.meta.env.VITE_ENV === "PROD" ? "" : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
  status_waiting_room: "CSEOF",
  url_waiting_room: "/producto/creditosimple/esperando_ofertas",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_tBa1HDVGi",
      userPoolClientId: "6ah7hc05bl7n6rqft7tdp7g8b3",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_76FjagSZI",
      userPoolClientId: "4hukgnioi4gqqkig3dr8slbp7k",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
